<template>
  <div class="p-2 text-left bg-white fw-bold rounded border border-white">
    <div class="d-flex justify-content-between">
      <div class="mt-0">
        <div v-if="vehicle !== undefined" class="text-sm-secondary">
          {{ vehicleStatus ?? "W magazynie" }}
        </div>
        <div v-if="driver !== undefined" class="text-sm-secondary">
          {{ driver.status ?? 'Nie określono' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'

export default {
  name: 'StatusCell',
  props: ['vehicle', 'driver', 'vehicleStatus'],
  methods: {
    // async checkStatus () {
    //   const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
    //   try {
    //     const tasks = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Task`, config)).data
    //     tasks.forEach(task => {
    //       if (task.auto !== null && task.auto.id === this.vehicle.id) {
    //         this.vehicleStatus = 'W trasie'
    //       }
    //     })
    //   } catch (e) {
    //     console.log(e)
    //   }
    // }
  }
}
</script>

<style scoped>
.text-left {
  text-align: left;
}

.text-sm {
  font-size: .8rem;
}

.text-sm-secondary {
  font-size: .6rem;
}

.text-xs {
  font-size: .5rem;
}

.text-xl {
  font-size: 1.2rem;
}

.text-darker {
  color: #bbb;
}

.bg-light-green {
  background-color: #47d147;
}
</style>
